import { useEffect, useMemo, useState } from "react"
import media from "../helpers/media"

interface IRenderOn {
  xs: boolean
  sm: boolean
  md: boolean
  lg: boolean
  xl: boolean
  smOrDown: boolean
  smOrUp: boolean
  mdOrDown: boolean
  mdOrUp: boolean
  lgOrDown: boolean
  lgOrUp: boolean
}

export const useRenderOn = (): IRenderOn => {
  const [width, setWidth] = useState(
    typeof window !== "undefined" && window.innerWidth
  )

  const updateWidth = (): void =>
    setWidth(typeof window !== "undefined" && window.innerWidth)

  useEffect(() => {
    window.addEventListener("resize", updateWidth)

    return (): void =>
      window.removeEventListener("resize", updateWidth)
  }, [])

  const memo = useMemo(() => {
    const xs = width < media.size.mobile
    const sm = width >= media.size.mobile && width < media.size.tablet
    const md = width >= media.size.tablet && width < media.size.laptop
    const lg =
      width >= media.size.laptop && width < media.size.desktop
    const xl = width >= media.size.desktop

    const ret = {
      xs,
      sm,
      md,
      lg,
      xl,

      smOrDown: xs || sm,
      smOrUp: sm || md || lg || xl,

      mdOrDown: xs || sm || md,
      mdOrUp: md || lg || xl,

      lgOrDown: xs || sm || md || lg,
      lgOrUp: lg || xl,
    }

    return ret
  }, [width])

  return memo
}
